import { Image } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import './style.scss';

const SidebarLogo = () => {
  const logo = useSelector((state: RootState) => state.setting.logo);

  return (
    <div className="sidebar-logo-container d-flex justify-content-center align-items-center">
      {
        <Image
          width={102}
          height={36}
          src={logo || 'images/mos-main.png'}
          alt={logo || 'images/mos-main.png'}
          fallback="images/mos-main.png"
          preview={false}
        />
      }
    </div>
  );
};

export default SidebarLogo;
